export default "https://cdn-static.gokick.com/assets/ed6531e95fd3f911890bedfaed34e81f4e5a2128/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";